import { withTheme } from '@ycos/fela'
import CMHero from './cm'

export default withTheme(CMHero)
